<template>
  <div class="row">
    <div class="col col-md-10 offset-md-1 text-center">
      <div class="d-flex justify-content-between">

        <Combo
              :itens="$global.sites_filtro()"
              v-model="filtroSite"
              style="max-width:150px;margin-right:10px"
              v-if="retornaSite() !== 'Share' && retornaSite() !== 'Stream1x2' && retornaSite() !== '7live'"
            />

        <input
          class="form-control"
          style="margin-right:10px"
          type="text"
          placeholder="Email..."
          v-model="filtroUsuario"
          @keyup="keyupFiltroUsuario"
        />

        <button
          type="button"
          class="btn btn-outline-primary btn-sm"
          style
          @click="carregarItens()"
        >Filtrar</button>
      </div>

      <hr />

      <div class="rowLista">
        <div class="list-group-item list-group-item-dark text-left">
          <div class="row">
            <div class="col text-center" style="max-width:100px">
              <h5 style="margin-top:9px">#</h5>
            </div>
            <div class="col">
              <h5 style="margin-top:9px">Usuário ({{this.itens.length}})</h5>
            </div>
            <div class="col col-md-3 text-center">
              <h5 style="margin-top:9px">Sessões ({{sessoesTotais}})</h5>
            </div>
          </div>
        </div>
        <div
          class="list-group-item list-group-item-action text-left"
          v-for="item in itens"
          :key="item.id"
          :item="item"
        >
          <div class="row">
            <div class="col text-center" style="max-width:100px;">
              <button @click="desconectar(item._id)" type="button" class="btn btn-danger btn-sm" style="zoom:0.7;margin-top: 17px;margin-bottom: 20px; margin-left: 10px;">Desconectar</button>
            </div>
            <div class="col">
              <h5 style="margin-top:9px">{{ item._id }}</h5>
            </div>
            <div class="col col-md-3 text-center">
              
                 <h5 style="margin-top:9px">{{ item.total }}</h5>
              
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import Combo from "../components/Combo.vue";
//import ListSessaoViewDetalhes from "./ListSessaoViewDetalhes.vue";

export default {
  name: "ListSessaoLogin",
  components: { Combo },
  props: { itensLimit: { type: Number, default: 10000 } },
  methods: {
    retornaSite()
    {
      return this.$site;
    },
    /*
    abrirAcessos(evento,usuario){

      //this.$refs.listSessaoViewDetalhes.carregarItens(evento,usuario);

    },*/
    async carregarItens() {
      
      var filtros = "";

      this.itens = [];

      filtros += "?1";

      if (this.filtroUsuario !== "") {
        filtros += "&usuario=" + this.filtroUsuario;
      }

      if(this.filtroSite !== "Todos")
      {
        filtros += "&site=" + this.filtroSite;
      }

      filtros += "&_limit=" + this.itensLimit;

      const response = await api.get("/sessao/list" + filtros);
      api.valid(response.data, this.$router);

      this.itens = response.data.itens;
      
    },
    keyupFiltroUsuario() {
      clearTimeout(this.timerFiltroUsuario);

      var obj = this;

      this.timerFiltroUsuario = setTimeout(function () {
        obj.carregarItens();
      }, 1000);
    },
    formatDateTime(datetime) {
      if (!datetime) return null;
      if (datetime && datetime != null && datetime != "") {
        var options = {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          //timeZoneName: "short",
          //timeZone: "UTC"
        };
        datetime = new Date(datetime);
        var portugueseTime = new Intl.DateTimeFormat(
          ["pt-BR", "pt-PT"],
          options
        );
        return portugueseTime.format(datetime);
      } else {
        return null;
      }
    },
    async desconectar(email)
    {
      var desconectar = confirm("Deseja desconectar todas as sessões deste cliente ?");

      if (desconectar == true) {
        await api.post("/sessao/desconectar",{usuarioEmail:email});
        this.carregarItens();
      }

    }
  },
  mounted() {
    
  },
  computed: {
    sessoesTotais: function () {
      return this.itens.reduce(function (a, b) {
        return a + b.total;
      }, 0);
    },
  },
  data: function () {
    return {
      itens: [],
      filtroSite:"Todos",
      filtroUsuario: "",
      timerFiltroUsuario:null
    };
  },
};
</script>

<style>
.textoResumo {
  margin-bottom: 0px;
}
.rowLista {
  margin-bottom: 15px;
}

.rowDivisor {
  margin-top: 0px;
  margin-bottom: 15px;
  margin-top: 15px;
}
</style>
